import React, { useState, useEffect, useCallback } from "react";
import Table from "../../common/Table/table";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import AddUpdateModal from "./AddUpdateModal";
import ViewMembershipModal from "./viewMemberModal";
import {
  createMembershipData,
  getAllMembership,
  resetMessage,
  resetUpdateMessages,
  updateMembershipSlice,
  resetDeleteMessages,
  deleteMembershipSlice,
} from "../../../store/slices/membershipSlice";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";

const ViewMembership = () => {
  const dispatch = useDispatch();
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const [modalVisible, setModalVisible] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  const {
    memberships,
    membershipErrorMessage,
    membershipSuccessMessage,
    membershipUpdateErrorMessage,
    membershipUpdateSuccessMessage,
    membershipDeleteErrorMessage,
    membershipDeleteSuccessMessage,
    searchMessage,
    currentPage,
    totalPages,
    totalCount,
    loading,
  } = useSelector((state) => state.membership);
  const initialState = {
    id: "",
    name: "",
    discountPercentage: "",
    clinicId: "",
    status: "Active",
  };
  const [formData, setFormData] = useState(initialState);
  const [inputError, setInputError] = useState({
    name: false,
    discountPercentage: false,
  });
  const fetchMembership = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (!clinicId || !token) return;

      dispatch(
        getAllMembership({
          clinicId,
          token,
          status: ["Active", "Inactive"],
          currentPage: page,
          limit: lim,
          name: search,
        })
      );
    },
    [dispatch, token, clinicId, searchValue, pageLimit]
  );
  useEffect(() => {
    fetchMembership();
  }, [fetchMembership]);
  const handlePageChange = (page) => {
    fetchMembership(page, pageLimit, searchValue);
  };
  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchMembership(1, newLimit, searchValue);
  };
  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchValue(value);
      fetchMembership(1, pageLimit, value);
    },
    [fetchMembership, pageLimit]
  );
  useEffect(() => {
    showTostifyMessageAndReset(
      membershipSuccessMessage,
      showToastifySuccess,
      resetMessage
    );
    showTostifyMessageAndReset(
      membershipErrorMessage,
      showToastifyError,
      resetMessage
    );
    showTostifyMessageAndReset(
      membershipUpdateSuccessMessage,
      showToastifySuccess,
      resetUpdateMessages
    );
    showTostifyMessageAndReset(
      membershipUpdateErrorMessage,
      showToastifyError,
      resetMessage
    );
    showTostifyMessageAndReset(
      membershipDeleteSuccessMessage,
      showToastifySuccess,
      resetDeleteMessages
    );
    showTostifyMessageAndReset(
      membershipDeleteErrorMessage,
      showToastifyError,
      resetDeleteMessages
    );
  }, [
    membershipErrorMessage,
    membershipSuccessMessage,
    membershipUpdateSuccessMessage,
    membershipUpdateErrorMessage,
    membershipDeleteSuccessMessage,
    membershipDeleteErrorMessage,
    showTostifyMessageAndReset,
  ]);

  const tableHead = [
    { title: "Name", key: "name" },
    { title: "discountPercentage", key: "discountPercentage" },
  ];

  const handleEdit = (item) => {
    setFormData({
      id: item?.id,
      name: item?.name,
      discountPercentage: item?.discountPercentage,
    });
    setIsUpdateMode(true);
    setModalVisible(true);
  };

  const handlemodal = () => {
    setIsUpdateMode(false);
    setFormData(initialState);
    setModalVisible(true);
  };
  const handleShowGlobalViewModal = (membershipDetails) => {
    setFormData({
      id: membershipDetails?.id,
      name: membershipDetails?.name,
      discountPercentage: membershipDetails?.discountPercentage,
    });
    setViewModal(true);
  };

  const handleDelete = (item) => {
    setDeleteModal(true);
    setFormData({ id: item?.id, name: item?.name });
  };
  const handleDeleteMembership = async () => {
    try {
      await dispatch(
        deleteMembershipSlice({
          clinicId,
          id: formData?.id,
          token,
        })
      );
      setDeleteModal(false);
    } catch (err) {
      console.error(err);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleAddMembership = async (e) => {
    e.preventDefault();
    const { name, discountPercentage } = inputError;
    if (name || discountPercentage) {
      return;
    }
    try {
      if (isUpdateMode) {
        await dispatch(
          updateMembershipSlice({
            ...formData,
            clinicId,
            token,
          })
        );
      } else {
        await dispatch(
          createMembershipData({
            ...formData,
            clinicId,
            token,
          })
        );
      }
      fetchMembership();
      setModalVisible(false);
      setIsUpdateMode(false);
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      <Table
        tableHead={tableHead}
        tableBody={
          memberships &&
          memberships?.map((item) => ({
            id: item?._id,
            name: item?.name,
            discountPercentage: item?.discountPercentage,
            clinicId: item?.clinic?._id,
          }))
        }
        addModal={handlemodal}
        handleSearch={handleSearch}
        searchValue={searchValue}
        handleEdit={handleEdit}
        membershipErrorMessage={searchMessage}
        handleDelete={handleDelete}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        handleAddBtn={true}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
      />
      <AddUpdateModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        formData={formData}
        handleAddMembership={handleAddMembership}
        setFormData={setFormData}
        handleChange={handleChange}
        isUpdateMode={isUpdateMode}
        setIsUpdateMode={setIsUpdateMode}
        setInputError={setInputError}
      />
      <ViewMembershipModal
        viewModal={viewModal}
        setViewModal={setViewModal}
        membershipData={formData}
      />
      <Modal centered show={deleteModal} onHide={() => setDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delelte Membership</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure You want to delete <b>{formData?.name}</b>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setDeleteModal(false)}
            className="p-2"
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleDeleteMembership}
            className="p-2"
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ViewMembership;
